import { DocumentItemList } from '../../components/document/DocumentItemList';
import { useFetchAccountDocuments } from '../../hooks/useFetchAccountDocument';

type Props = {
  compressed?: boolean;
};

export const AccountDocuments = ({ compressed }: Props) => {
  const { data, isLoading } = useFetchAccountDocuments();

  return <DocumentItemList isLoading={isLoading} documentItems={data?.items} compressed={compressed} />;
};
